import React from "react";
import { string } from "prop-types";

import * as S from "./styled";

const HeaderNavLink = ({ children, ...props }) => (
  <S.HeaderNavLink {...props}>{children}</S.HeaderNavLink>
);

HeaderNavLink.propTypes = {
  children: string.isRequired
};

export default HeaderNavLink;
